import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IBarcodeStyle } from "../../../../documaker/domain/format/objects";

export interface IBarcodeStylePropertyEditable {
  barcodeStyle(): IPropertyEditable<IBarcodeStyle>;
}

export function instanceOfIBarcodeStylePropertyEditable(instance: any): instance is IBarcodeStylePropertyEditable {
  return instance
      && instance.barcodeStyle
      && instanceOfIPropertyEditable<IBarcodeStyle>(instance.barcodeStyle());
}
